import { ShoppingCartItemTypeEnum } from "../generated/graphql";
import * as ShoppingCartItemPriceBreakdown from './ShoppingCartItemPriceBreakdown';
import { take } from "../util/takePayload";
export const fromGql = (gqlItem) => (Object.assign(Object.assign({}, take(gqlItem, 'typeHash', 'name', 'itemId', 'itemType', 'count', 'amount', 'details')), { seatingInfo: seatingInfoFromDetails(gqlItem), breakdown: gqlItem.breakdown ? ShoppingCartItemPriceBreakdown.fromGql(gqlItem.breakdown) : undefined }));
const seatingInfoFromDetails = ({ itemType, details }) => {
    if (itemType != ShoppingCartItemTypeEnum.SeatTicket) {
        return undefined;
    }
    const seatIds = details.seatIds;
    if (!seatIds) {
        return undefined;
    }
    return { seatIds: seatIds.map((seatDetails) => seatDetails.seatId) };
};
//# sourceMappingURL=ShoppingCartItem.js.map